import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { UpdateRegistrationPasswordPage } from './update-registration-password';

@NgModule({
  declarations: [
    UpdateRegistrationPasswordPage,
  ],
  imports: [
    IonicPageModule.forChild(UpdateRegistrationPasswordPage),
  ],
  exports: [
    UpdateRegistrationPasswordPage
  ]
})
export class UpdateRegistrationPasswordPageModule { }



// WEBPACK FOOTER //
// ./src/pages/update-registration-password/update-registration-password.module.ts